import { ErrorBoundary } from "react-error-boundary"
import React from "react"
import { translations } from "../../../utils/translations/translations-manager"
import { XCircleIcon } from '@heroicons/react/24/outline';
import { FilledButton } from "../common/buttons/FilledButton";
import { logger } from "../../../utils/logging/logger";
import { LogSeverity } from "../../../types/usage/log";

export function UnhandledErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary
      onError={(error, info) => {
        void logger('unhandled_error', { errorName: error.name, errorMessage: error.message, details: { error, error_info: info } }, LogSeverity.Critical)
      }}
      FallbackComponent={({ resetErrorBoundary }: { resetErrorBoundary: (...args: unknown[]) => void }) => {
        return (
          <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-center">
            <XCircleIcon className='h-10 w-10 stroke-red-500' />
            <h1 className="text-3xl font-bold text-gray-800 mt-2">{translations.texts.something_went_wrong.toString()}!</h1>
            <FilledButton className="mt-10" label={translations.texts.retry.toString()} onClick={resetErrorBoundary} />
          </div>
        )
      }}>
      {children}
    </ErrorBoundary>
  )
}